import { render } from "./Withdrawal.vue?vue&type=template&id=f91cd28c&scoped=true&ts=true"
import script from "./Withdrawal.vue?vue&type=script&lang=ts"
export * from "./Withdrawal.vue?vue&type=script&lang=ts"

import "./Withdrawal.vue?vue&type=style&index=0&id=f91cd28c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91cd28c"]])

export default __exports__